import React from "react";
var __jsx = React.createElement;
/** ------- Imports Dependencies ------- */
import Spacing from "@/_LayoutsRelated/spacing/Spacing";

/** ------- Import Styles ------- */
import stl from '../styles/InstallmentCalculatorSection.module.css';
import cm from "../styles/Common.module.css";
import { InstallmentCalculatorProvider } from "@/_MiniApps/Installment-calculator/InstallmentCalculatorContext";
import InstallmentCalculatorLanding from "@/sections/finance-calculator-landing/views/InstallmentCalculatorLanding";
import { useState } from "react";
import { useTranslation } from "@i18n";

/** ------- Type Declarations ------- */

/** ------- Component ------- */

var InstallmentCalculatorSection = function InstallmentCalculatorSection(_ref) {
  var initialCashPrice = _ref.initialCashPrice;
  var _useState = useState(initialCashPrice),
    cashPrice = _useState[0],
    setCashPrice = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onChangeCashPrice = function onChangeCashPrice(cash_price) {
    setCashPrice(cash_price);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement("section", {
    className: stl.installmentCalculatorSection
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.px24
  }, /*#__PURE__*/React.createElement("h2", {
    className: [cm.cmTitle, stl.alignStart, stl.alignMiddleMobile].join(" ")
  }, t("easily_estimate_car_financing_value", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement(InstallmentCalculatorProvider, {
    carCondition: "used",
    cashPrice: cashPrice
  }, /*#__PURE__*/React.createElement(InstallmentCalculatorLanding, {
    onChangeCashPrice: onChangeCashPrice,
    cashPrice: cashPrice
  })))));
};
export default InstallmentCalculatorSection;